import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button, IconButton, styled } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const BannerContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '600px',
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    height: '400px',
  },
}));

const Slide = styled(Box)(({ theme, image }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${image})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  transition: 'all 0.8s ease-in-out',
  display: 'flex',
  alignItems: 'center',
}));

const DotIndicator = styled(IconButton)(({ theme, active }) => ({
  padding: 4,
  color: active ? theme.palette.secondary.main : 'white',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

const slides = [
  {
    image: '/images/banner1.jpg',
    title: 'Transform Your Dream Home Into Reality',
    subtitle: 'Get home loans starting at 7.15%* p.a. with quick approval',
    buttonText: 'Apply Now',
  },
  {
    image: '/images/banner2.jpg',
    title: 'Fast & Hassle-Free Process',
    subtitle: 'Minimal documentation with same-day processing available',
    buttonText: 'Check Eligibility',
  },
  {
    image: '/images/banner3.jpg',
    title: 'Expert Financial Guidance',
    subtitle: 'Our specialists help you choose the perfect home loan solution',
    buttonText: 'Talk to Expert',
  },
];

function CarouselBanner({ onApplyClick }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <BannerContainer>
      {slides.map((slide, index) => (
        <Slide
          key={index}
          image={slide.image}
          sx={{
            opacity: currentSlide === index ? 1 : 0,
            visibility: currentSlide === index ? 'visible' : 'hidden',
          }}
        >
          <Container maxWidth="lg">
            <Box sx={{ maxWidth: 600, color: 'white' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2rem', md: '3.5rem' },
                  fontWeight: 700,
                  mb: 2,
                  textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                }}
              >
                {slide.title}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: '1.2rem', md: '1.5rem' },
                  mb: 4,
                  textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                }}
              >
                {slide.subtitle}
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                onClick={onApplyClick}
                sx={{
                  py: 1.5,
                  px: 4,
                  fontSize: '1.1rem',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 12px rgba(0,0,0,0.2)',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                {slide.buttonText}
              </Button>
            </Box>
          </Container>
        </Slide>
      ))}


      <Box
        sx={{
          position: 'absolute',
          bottom: 24,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: 1,
          zIndex: 2,
        }}
      >
        {slides.map((_, index) => (
          <DotIndicator
            key={index}
            active={currentSlide === index}
            onClick={() => setCurrentSlide(index)}
          >
            <FiberManualRecordIcon fontSize="small" />
          </DotIndicator>
        ))}
      </Box>
    </BannerContainer>
  );
}

export default CarouselBanner; 